import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.dilanaslan.com/api";

// Tüm müşterileri çek
export const fetchCustomers = createAsyncThunk(
  "customers/fetchCustomers",
  async ({ status, search } = {}) => {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (search) params.append("search", search);

    const res = await axios.get(`${BASE_URL}/customers?${params.toString()}`);
    return res.data;
  }
);

// Tek müşteri detayı çek (çocukları ile)
export const fetchCustomerById = createAsyncThunk(
  "customers/fetchCustomerById",
  async (id) => {
    const res = await axios.get(`${BASE_URL}/customers/${id}`);
    return res.data;
  }
);

// Yeni müşteri oluştur
export const createCustomer = createAsyncThunk(
  "customers/createCustomer",
  async (customerData, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}/customers`, customerData);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Müşteri oluşturulamadı"
      );
    }
  }
);

// Müşteri güncelle
export const updateCustomer = createAsyncThunk(
  "customers/updateCustomer",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${BASE_URL}/customers/${id}`, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Müşteri güncellenemedi"
      );
    }
  }
);

// Müşteri sil
export const deleteCustomer = createAsyncThunk(
  "customers/deleteCustomer",
  async (id) => {
    await axios.delete(`${BASE_URL}/customers/${id}`);
    return id;
  }
);

const customerSlice = createSlice({
  name: "customers",
  initialState: {
    items: [],
    selectedCustomer: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedCustomer: (state) => {
      state.selectedCustomer = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch By ID
      .addCase(fetchCustomerById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCustomer = action.payload;
      })
      .addCase(fetchCustomerById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create
      .addCase(createCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.items.unshift(action.payload);
      })
      .addCase(createCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update
      .addCase(updateCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.map((customer) =>
          customer._id === action.payload._id ? action.payload : customer
        );
        if (state.selectedCustomer?._id === action.payload._id) {
          state.selectedCustomer.customer = action.payload;
        }
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.items = state.items.filter((c) => c._id !== action.payload);
        if (state.selectedCustomer?.customer._id === action.payload) {
          state.selectedCustomer = null;
        }
      });
  },
});

export const { clearError, clearSelectedCustomer } = customerSlice.actions;
export default customerSlice.reducer;
